let en = {
  "values": {
    "chess:q": "Q",
    "chess:k": "K",
    "chess:r": "R",
    "chess:b": "B",
    "chess:n": "N",
    "chess:Q": "Q",
    "chess:K": "K",
    "chess:R": "R",
    "chess:B": "B",
    "chess:N": "N",
    "buttons:flipper": "Flip the sides of the board",
    "buttons:first": "Go to first move",
    "buttons:prev": "Go to previous move",
    "buttons:next": "Go to next move",
    "buttons:play": "Play / stop playing all moves",
    "buttons:last": "Go to last move",
    "buttons:deleteVar": "Delete variation",
    "buttons:promoteVar": "Promote variation",
    "buttons:deleteMoves": "Delete rest moves from here",
    "buttons:nags": "NAGs menu",
    "buttons:pgn": "Display PGN of current game",
    "buttons:hidePGN": "Hide the displayed PGN",
    "nag:$0": "null annotation",
    "nag:$1": "good move",
    "nag:$1_menu": "Good move",
    "nag:$2": "poor move or mistake",
    "nag:$2_menu": "Mistake",
    "nag:$3": "very good or brilliant move",
    "nag:$3_menu": "Brilliant move",
    "nag:$4": "very poor move or blunder",
    "nag:$4_menu": "Blunder",
    "nag:$5": "speculative or interesting move",
    "nag:$5_menu": "Interesting move",
    "nag:$6": "questionable or dubious move",
    "nag:$6_menu": "Dubious move",
    "nag:$7": "forced move (all others lose quickly) or only move",
    "nag:$7_menu": "Forced move",
    "nag:$8": "singular move (no reasonable alternatives)",
    "nag:$8_menu": "Singular move",
    "nag:$9": "worst move",
    "nag:$10": "drawish position or even",
    "nag:$10_menu": "Equal position",
    "nag:$11": "equal chances, quiet position",
    "nag:$12": "equal chances, active position",
    "nag:$13": "unclear position",
    "nag:$13_menu": "Unclear position",
    "nag:$14": "White has a slight advantage",
    "nag:$14_menu": "White is slightly better",
    "nag:$15": "Black has a slight advantage",
    "nag:$15_menu": "Black is slightly better",
    "nag:$16": "White has a moderate advantage",
    "nag:$16_menu": "White is better",
    "nag:$17": "Black has a moderate advantage",
    "nag:$17_menu": "Black is better",
    "nag:$18": "White has a decisive advantage",
    "nag:$18_menu": "White is winning",
    "nag:$19": "Black has a decisive advantage",
    "nag:$19_menu": "Black is winning",
    "nag:$20": "White has a crushing advantage (Black should resign)",
    "nag:$21": "Black has a crushing advantage (White should resign)",
    "nag:$22": "White is in zugzwang",
    "nag:$22_menu": "Zugzwang",
    "nag:$23": "Black is in zugzwang",
    "nag:$24": "White has a slight space advantage",
    "nag:$24_menu": "Space advantage",
    "nag:$25": "Black has a slight space advantage",
    "nag:$26": "White has a moderate space advantage",
    "nag:$27": "Black has a moderate space advantage",
    "nag:$28": "White has a decisive space advantage",
    "nag:$29": "Black has a decisive space advantage",
    "nag:$30": "White has a slight time (development) advantage",
    "nag:$31": "Black has a slight time (development) advantage",
    "nag:$32": "White has a moderate time (development) advantage",
    "nag:$32_menu": "Time advantage",
    "nag:$33": "Black has a moderate time (development) advantage",
    "nag:$34": "White has a decisive time (development) advantage",
    "nag:$35": "Black has a decisive time (development) advantage",
    "nag:$36": "White has the initiative",
    "nag:$36_menu": "Attack",
    "nag:$37": "Black has the initiative",
    "nag:$38": "White has a lasting initiative",
    "nag:$39": "Black has a lasting initiative",
    "nag:$40": "White has the attack",
    "nag:$40_menu": "Initiative",
    "nag:$41": "Black has the attack",
    "nag:$42": "White has insufficient compensation for material deficit",
    "nag:$43": "Black has insufficient compensation for material deficit",
    "nag:$44": "White has sufficient compensation for material deficit",
    "nag:$44_menu": "With compensation",
    "nag:$45": "Black has sufficient compensation for material deficit",
    "nag:$46": "White has more than adequate compensation for material deficit",
    "nag:$47": "Black has more than adequate compensation for material deficit",
    "nag:$48": "White has a slight center control advantage",
    "nag:$49": "Black has a slight center control advantage",
    "nag:$50": "White has a moderate center control advantage",
    "nag:$51": "Black has a moderate center control advantage",
    "nag:$52": "White has a decisive center control advantage",
    "nag:$53": "Black has a decisive center control advantage",
    "nag:$54": "White has a slight kingside control advantage",
    "nag:$55": "Black has a slight kingside control advantage",
    "nag:$56": "White has a moderate kingside control advantage",
    "nag:$57": "Black has a moderate kingside control advantage",
    "nag:$58": "White has a decisive kingside control advantage",
    "nag:$59": "Black has a decisive kingside control advantage",
    "nag:$60": "White has a slight queenside control advantage",
    "nag:$61": "Black has a slight queenside control advantage",
    "nag:$62": "White has a moderate queenside control advantage",
    "nag:$63": "Black has a moderate queenside control advantage",
    "nag:$64": "White has a decisive queenside control advantage",
    "nag:$65": "Black has a decisive queenside control advantage",
    "nag:$66": "White has a vulnerable first rank",
    "nag:$67": "Black has a vulnerable first rank",
    "nag:$68": "White has a well protected first rank",
    "nag:$69": "Black has a well protected first rank",
    "nag:$70": "White has a poorly protected king",
    "nag:$71": "Black has a poorly protected king",
    "nag:$72": "White has a well protected king",
    "nag:$73": "Black has a well protected king",
    "nag:$74": "White has a poorly placed king",
    "nag:$75": "Black has a poorly placed king",
    "nag:$76": "White has a well placed king",
    "nag:$77": "Black has a well placed king",
    "nag:$78": "White has a very weak pawn structure",
    "nag:$79": "Black has a very weak pawn structure",
    "nag:$80": "White has a moderately weak pawn structure",
    "nag:$81": "Black has a moderately weak pawn structure",
    "nag:$82": "White has a moderately strong pawn structure",
    "nag:$83": "Black has a moderately strong pawn structure",
    "nag:$84": "White has a very strong pawn structure",
    "nag:$85": "Black has a very strong pawn structure",
    "nag:$86": "White has poor knight placement",
    "nag:$87": "Black has poor knight placement",
    "nag:$88": "White has good knight placement",
    "nag:$89": "Black has good knight placement",
    "nag:$90": "White has poor bishop placement",
    "nag:$91": "Black has poor bishop placement",
    "nag:$92": "White has good bishop placement",
    "nag:$93": "Black has good bishop placement",
    "nag:$94": "White has poor rook placement",
    "nag:$95": "Black has poor rook placement",
    "nag:$96": "White has good rook placement",
    "nag:$97": "Black has good rook placement",
    "nag:$98": "White has poor queen placement",
    "nag:$99": "Black has poor queen placement",
    "nag:$100": "White has good queen placement",
    "nag:$101": "Black has good queen placement",
    "nag:$102": "White has poor piece coordination",
    "nag:$103": "Black has poor piece coordination",
    "nag:$104": "White has good piece coordination",
    "nag:$105": "Black has good piece coordination",
    "nag:$106": "White has played the opening very poorly",
    "nag:$107": "Black has played the opening very poorly",
    "nag:$108": "White has played the opening poorly",
    "nag:$109": "Black has played the opening poorly",
    "nag:$110": "White has played the opening well",
    "nag:$111": "Black has played the opening well",
    "nag:$112": "White has played the opening very well",
    "nag:$113": "Black has played the opening very well",
    "nag:$114": "White has played the middlegame very poorly",
    "nag:$115": "Black has played the middlegame very poorly",
    "nag:$116": "White has played the middlegame poorly",
    "nag:$117": "Black has played the middlegame poorly",
    "nag:$118": "White has played the middlegame well",
    "nag:$119": "Black has played the middlegame well",
    "nag:$120": "White has played the middlegame very well",
    "nag:$121": "Black has played the middlegame very well",
    "nag:$122": "White has played the ending very poorly",
    "nag:$123": "Black has played the ending very poorly",
    "nag:$124": "White has played the ending poorly",
    "nag:$125": "Black has played the ending poorly",
    "nag:$126": "White has played the ending well",
    "nag:$127": "Black has played the ending well",
    "nag:$128": "White has played the ending very well",
    "nag:$129": "Black has played the ending very well",
    "nag:$130": "White has slight counterplay",
    "nag:$131": "Black has slight counterplay",
    "nag:$132": "White has moderate counterplay",
    "nag:$132_menu": "Counterplay",
    "nag:$133": "Black has moderate counterplay",
    "nag:$134": "White has decisive counterplay",
    "nag:$135": "Black has decisive counterplay",
    "nag:$136": "White has moderate time control pressure",
    "nag:$136_menu": "Time trouble",
    "nag:$137": "Black has moderate time control pressure",
    "nag:$138": "White has severe time control pressure",
    "nag:$139": "Black has severe time control pressure",
    "nag:$140": "With the idea",
    "nag:$140_menu": "With the idea",
    "nag:$146": "Novelty",
    "nag:$146_menu": "Novelty"
  }
}

export default en